import { useState, useEffect } from 'react';
import { DialogUI, ButtonUI } from '.';

export default function ConfirmDialogUI({
  handleChangeElement,
  handleChangeJoker1Element,
  handleOpen,
  show,
  onHide,
  message,
  title,
  confirmButtonText,
  joker1ButtonText,
  joker2ButtonText,
  handleChangeJoker2Element,
  showConfirmButton = true,
  largeButtons,
  maxWidth,
  disabled,
}) {
  const [locked, setLocked] = useState(false);

  useEffect(() => {
    if (show) setLocked(false);
  }, [show]);

  const makeOnceHandler = (fn) => async (e) => {
    if (locked || disabled) return;
    setLocked(true);
    try {
      const ret = fn?.(e);
      if (ret && typeof ret.then === 'function') {
        await ret;
      }
    } catch (err) {
      setLocked(false);
      throw err;
    }
  };

  const handleHide = (e) => {
    setLocked(false);
    onHide?.(e);
  };

  return (
    <DialogUI
      open={show}
      handleOpen={handleOpen}
      onClose={handleHide}
      headerContent={title ?? 'Művelet megerősítése'}
      fullWidth={true}
      maxWidth={maxWidth}
    >
      <div className="relative">
        <div className="mt-2 flex gap-10 items-center justify-center z-50">
          <div className="relative">
            <div className="relative mt-5">
              <p className={`${largeButtons ? 'text-3xl' : 'text-2xl'} text-labelColor`}>
                {message ?? `Megerősíti a műveletet?`}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className={`${largeButtons ? 'justify-evenly' : 'justify-center'} px-4 mt-8 flex gap-3`}>
        {showConfirmButton && (
          <ButtonUI
            type="button"
            text={confirmButtonText ?? 'Megerősítés'}
            className={`${largeButtons ? 'w-[200px] h-[200px] text-2xl bg-greenAccent' : 'bg-success'}`}
            onClick={makeOnceHandler(handleChangeElement)}
            disabled={disabled || locked}
          />
        )}
        {joker1ButtonText && (
          <ButtonUI
            type="button"
            text={joker1ButtonText}
            className={`${largeButtons ? 'w-[200px] h-[200px] text-2xl' : ''} bg-warning`}
            onClick={makeOnceHandler(handleChangeJoker1Element)}
            disabled={disabled || locked}
          />
        )}
        {joker2ButtonText && (
          <ButtonUI
            type="button"
            text={joker2ButtonText}
            className={`${largeButtons ? 'w-[200px] h-[200px] text-2xl' : ''} bg-primary`}
            onClick={makeOnceHandler(handleChangeJoker2Element)}
            disabled={disabled || locked}
          />
        )}
        <ButtonUI
          type="button"
          text="Mégse"
          className={`${largeButtons ? 'text-2xl w-[200px] h-[200px]' : ''}`}
          color="blue-gray"
          variant="gradient"
          onClick={handleHide}
        ></ButtonUI>
      </div>
    </DialogUI>
  );
}
